import { useEffect, useState } from 'react'

// Hook
export const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: 1000,
    height: 1000,
    outerHeight: 1000,
  })
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        outerHeight: window.outerHeight,
      })
      // Call handler right away so state gets updated with initial window size
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--rvh', `${vh}px`)
    }
    // Add event listener
    window.addEventListener('resize', handleResize)
    // Call handler right away so state gets updated with initial window size
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    document.documentElement.style.setProperty('--rvh', `${vh}px`)
    handleResize()
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount
  return windowSize
}
// Hook
export const useIsSp = () => {
  const { width } = useWindowSize()
  return width < 768
}
